export default __webpack_public_path__ + "img/olivertree_recordingstudio-01.d116d5dce68d383e3782348fcbd53309.png";